import { storageProvider } from '@root/services/StorageService';
import { useMemo } from 'react';

export function useStorage<T>(ns: string, lifecycle: 'memory' | 'cross-tab' = 'memory') {
    return useMemo(() => {
        const storage = storageProvider.get(ns, lifecycle);
        return {
            get: (id: string) => storage.get<T>(id),
            save: (id: string, value: T) => storage.save<T>(id, value),
            remove: (id: string) => storage.remove(id),
            getAll: () => storage.getAll<T>(),
        };
    }, [ns, lifecycle]);
}
